// extracted by mini-css-extract-plugin
module.exports = {"container":"Tag_container__rLVq5"};